// extracted by mini-css-extract-plugin
module.exports = {"item":"styles__item___1ycoN","badge":"styles__badge___31z5H","itemActive":"styles__itemActive___Smy5Z styles__item___1ycoN"};